module.exports = __webpack_public_path__ + "img/home-2.c303064e.webp";